import React from 'react';
import LegalPageLayout from './LegalPageLayout';

const TermsOfService: React.FC = () => {
  return (
    <LegalPageLayout title="Terms of Service">
      <h3>1. Acceptance of Terms</h3>
      <p>
        By accessing or using the ProGeoData API and website, you agree to be bound by these Terms of Service. 
        If you disagree with any part of the terms, you may not access the Service.
      </p>

      <h3>2. Use License</h3>
      <p>
        Permission is granted to temporarily download one copy of the materials (information or software) on ProGeoData's website for personal, non-commercial transitory viewing only. 
        This is the grant of a license, not a transfer of title, and under this license you may not:
      </p>
      <ul>
        <li>Modify or copy the materials;</li>
        <li>Use the materials for any commercial purpose, or for any public display (commercial or non-commercial) without an active subscription;</li>
        <li>Attempt to decompile or reverse engineer any software contained on ProGeoData's website;</li>
        <li>Remove any copyright or other proprietary notations from the materials; or</li>
        <li>Transfer the materials to another person or "mirror" the materials on any other server.</li>
      </ul>

      <h3>3. Data Accuracy</h3>
      <p>
        The materials appearing on ProGeoData's website could include technical, typographical, or photographic errors. 
        ProGeoData does not warrant that any of the materials on its website are accurate, complete, or current. 
        We act as an aggregator of public records and do not guarantee the real-time accuracy of state licensing board data.
      </p>

      <h3>4. Disclaimer</h3>
      <p>
        The materials on ProGeoData's website are provided on an 'as is' basis. 
        ProGeoData makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
      </p>

      <h3>5. Limitations</h3>
      <p>
        In no event shall ProGeoData or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on ProGeoData's website.
      </p>

      <h3>6. Governing Law</h3>
      <p>
        These terms and conditions are governed by and construed in accordance with the laws of Delaware and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.
      </p>
    </LegalPageLayout>
  );
};

export default TermsOfService;